import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const CloseIcon = (props?: SvgProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path
        d="M11 1L1 11M1 1L11 11"
        stroke="#4A4C50"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
